<template>
    <div class="main-services" :class="additionalClass">
        <div class="main-services__wrapper">
            <div v-if="!hideLeftBlock">
                <h2 class="h2 _mobile-visible" v-html="title"></h2>
                <p class="p1 _mobile-visible _mt-16" v-html="subtitle"></p>
            </div>
            <div class="main-services__left">
                <div v-if="!hideLeftBlock">
                    <h2 class="h2" v-html="title"></h2>
                    <p class="p1 _mt-16 " v-html="subtitle" v-if="subtitle"></p>
                </div>
                <div class="main-services__left-buttons" v-if="blocks.length > 3">
                    <div class="main-services__left-buttonl" :class="{ 'main-services__left-buttonl_disabled': counter === 3 }" @click="decrease">
                        <DIcon v-if="counter === 3" :name="EIcon.ARROW_LEFT" :size="EIconSize.S_24" :color="EIconColor.GREY_166" class="_flex-none" />
                        <DIcon v-else :name="EIcon.ARROW_LEFT" :size="EIconSize.S_24" :color="EIconColor.GREY_517" class="_flex-none" />
                    </div>

                    <div class="main-services__left-buttonr" :class="{ 'main-services__left-buttonr_disabled': counter === maxCounter }" @click="increase">
                        <DIcon v-if="counter === maxCounter" :name="EIcon.ARROW_RIGHT" :size="EIconSize.S_24" :color="EIconColor.GREY_166" class="_flex-none" />
                        <DIcon v-else :name="EIcon.ARROW_RIGHT" :size="EIconSize.S_24" :color="EIconColor.GREY_517" class="_flex-none" />
                    </div>
                </div>
            </div>
            <div class="main-services__main main-services__main_desktop swiper-container _mobile-hidden-flx">
                <div class="swiper-wrapper">
                    <div class="main-services__main-block swiper-slide" v-for="(block, index) in blocks" :key="index">
                        <a target="_blank" :href="block.link" v-if="block.link">
                            <div class="main-services__main-block-content">
                                <div class="main-services__main-icon" :class="block.icon"></div>
                                <div class="main-services__main-title" v-html="block.title"></div>
                                <p class="p1 _mt-16 _position-relative main-services__description" v-html="block.description"></p>
                            </div>
                        </a>

                        <div v-else>
                            <div class="main-services__main-block-content">
                                <div class="main-services__main-icon" :class="block.icon"></div>
                                <div class="main-services__main-title" v-html="block.title"></div>
                                <p class="p1 _mt-16 _position-relative main-services__description" v-html="block.description"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mobile block -->
            <horizontal-scroll index="0" line-color="gray-fourth" slider-color="gray-french" class="_mobile-visible _mt-0-24">
                <template #scrolled-content>
                    <div class="swiper-wrapper">
                        <a class="main-services__main-block swiper-slide" target="_blank" :href="block.link" v-for="(block, index) in blocks" :key="index">
                            <div class="main-services__main-block-content">
                                <div class="main-services__main-icon" :class="block.icon"></div>
                                <div class="main-services__main-title" v-html="block.title"></div>
                                <p class="p1 _mt-16 _position-relative main-services__description" v-html="block.description"></p>
                            </div>
                        </a>
                    </div>
                </template>
            </horizontal-scroll>
        </div>
    </div>
</template>

<script>
import horizontalScroll from '../../components/block/horizontalScroll.vue';
import Swiper from 'swiper';
import { DIcon, EIcon, ESize as EIconSize, EColor as EIconColor } from '@ahml/domrfbank-ui/elements/DIcon.js';

export default {
    name: "mainServices",
    components: { 
        horizontalScroll,
        DIcon
    },
    props: {
        blocks: {
            type: Array, default: () => []
        },
        title: {
            type: String, default: 'Полезные сервисы'
        },
        subtitle: {
            type: String,
            default: 'Удобные онлайн-сервисы и услуги от&nbsp;Банка ДОМ.РФ'
        },
        hideLeftBlock: {
            type: Boolean,
            default: false
        },
        additionalClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            counter: 0,
            mobileCounter: 0,
            maxCounter: 3,
            hideMobileBlur: false,
            mySlider: null,
            EIcon,
            EIconSize,
            EIconColor,
        }
    },
    methods: {
        initStepsSlider() {
            const config = {
                slidesPerView: 'auto',
                centeredSlides: false,
                loop: false,
                navigation: {
                    nextEl: '.main-services__left-buttonr',
                    prevEl: '.main-services__left-buttonl'
                },
                breakpoints: {
                    1001: {
                        centeredSlides: false,
                        loop: false,
                        allowTouchMove: false
                    }
                }
            }

            const configMobile = {
                slidesPerView: 'auto',
                centeredSlides: false,
                loop: true,
                pagination: {
                    clickable: true,
                }
            }

            this.mySwiper = new Swiper('.main-services__main_desktop', config);
            let stepSliderMobile = new Swiper('.main-services__main_mobile', configMobile);

            window.addEventListener('orientationchange', () => {
                if (stepSliderMobile && stepSliderMobile instanceof Swiper) {
                    stepSliderMobile.destroy(true, true);

                    setTimeout(() => {
                        stepSliderMobile = new Swiper('.main-services__main_mobile', configMobile);
                    }, 100);
                }
            });
        },
        increase() {
            return this.counter = this.counter >= this.maxCounter ? this.maxCounter : ++this.counter;
        },
        decrease() {
            return this.counter = this.counter <= 3 ? 3 : --this.counter;
        }
    },
    mounted() {
        this.initStepsSlider();
        this.maxCounter = this.$props.blocks.length;
        this.counter = this.$props.blocks.length > 3 ? 3 : this.$props.blocks.length;
    }
}
</script>

<style lang="scss">
	@import '../../assets/scss/base/_variables.scss';
	@import '../../assets/scss/base/_mixins.scss';
	@import '../../assets/scss/base/_functions.scss';

    $b: '.main-services';

    #{$b} {

        &__main {

            .swiper-pagination {
                display: none;

                @include mobile {
                    display: block;
                }

                .swiper-pagination-bullet-active {
                    background: $grey-1514!important;
                }
            }

            .swiper-pagination-bullets {
                bottom: 0px!important;
            }
        }
    }

</style>

<style lang="scss" scoped>
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

$b: '.main-services';

#{$b} {
    &__title {
        @include h2;
        opacity: 0;
        @include fluid('margin-bottom', $ind7, $ind-alt2);

        @include mobile {
            br {
                display: none;
            }
        }
    }

    &__description {
        z-index: 1;
    }

    &__content {
        flex-direction: column;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: flex-start;
        @include fluid('height', 500px, auto);

        @include mobile {
            flex-wrap: nowrap;
        }

        &.cards_services {
            @include fluid('height', 750px, auto);
        }
    }

    .service-card {
        opacity: 0;
    }

    .payment-card {
        @include mobile {
            margin-top: px2vw(12px, $base-mobile-viewport-width);
        }
    }

    &__wrapper {
        display: flex;
        width: 100%;
        height: auto;

        @include mobile {
            display: block;
            height: auto;
        }
    }

    &__left {
        position: relative;
        @include fluid('width', 176px);

        @include mobile {
            display: none;
        }

        &._shift {
            @include fluid('width', 380px);
        }

        &-buttons {
            @include fluid('margin-top', 96px);
            display: flex;
        }

        &-buttonl {
            display: flex;
            justify-content: center;
            align-items: center;
            @include fluid('margin-right', 16px);
            @include fluid('width', 32px);
            @include fluid('height', 32px);
            @include fluid('border-radius', 16px);
            background-color: $grey-109;
            cursor: pointer;

            &_disabled {
                background-color: $disabled-gray;
            }
        }

        &-buttonr {
            display: flex;
            justify-content: center;
            align-items: center;
            @include fluid('width', 32px);
            @include fluid('height', 32px);
            @include fluid('border-radius', 16px);
            background-color: $grey-109;
            cursor: pointer;

            &_disabled {
                background-color: $disabled-gray;
            }
        }
    }

    &__main {
        @include fluid('margin-left', 32px, 0px);
        display: flex;
        @include fluid('width', 904px);
        height: auto;
        position: relative;
        @include fluid('margin-top', 0px, 24px);
        visibility: visible;

        @include mobile {
            width: 100%;
        }

        &-wrapper {
            &_right {
                content: "";
                @include fluid('width', 56px);
                height: 100%;
                background: linear-gradient(270deg, $white-101 28.13%, rgba(255, 255, 255, 0) 100%);
                position: absolute;
                z-index: 100;
                right: 0;
            }

            &_left {
                content: "";
                @include fluid('width', 99px);
                height: 100%;
                background: url('/local/templates/redesign/src/assets/img/main/gradient-left.png');
                position: absolute;
                z-index: 100;
                left: 0;
            }

            &_rightmob::before {
                content: "";
                @include fluid('width', 56px);
                height: 100%;
                background: linear-gradient(270deg, $white-101 28.13%, rgba(255, 255, 255, 0) 100%);
                position: absolute;
                z-index: 100;
                right: 0;
            }
        }

        &-block {
            @include fluid('width', 280px, 272px);
            @include fluid('max-width', 280px, 272px);
            height: auto;
            @include fluid('border-radius', 32px, 24px);
            @include fluid('margin-right', 32px, 16px);
            @include fluid('margin-bottom', 0px, 16px);
            position: relative;
            visibility: visible;

            &-content {
                @include fluid('padding', 32px, 24px);
            }
        }

        &-block:before {
            content: '';
            @include fluid('border-radius', 32px, 24px);
            background-color: $grey-106;
            height: 100%;
            width: 100%;
            position: absolute;
            transition: all .3s ease;
            top: 0;
            right: 0;
            z-index: 1;
        }

        &-block:hover::before {
            transform: scale(1.02);
            background-color: $hover-white;
        }

        &-block:last-of-type {
            margin-right: 0px;
        }

        &-icon {
            @include fluid('width', 72px, 48px);
            @include fluid('height', 72px, 48px);
            background-position: no-repeat;
            background-size: contain;
            z-index: 2;
            position: relative;


            &_award {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/award.webp');
            }
            &_docs {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/document.svg');
            }

            &_escrow {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/escrow.svg');
            }

            &_refin {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/refin.svg');
            }

            &_credit {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/credit.svg');
            }

            &_holidays {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/holidays.svg');
            }

            &_pin {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/pin.svg');
            }

            &_escrow-refill {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/escrow-refill.svg');
            }

            &_it {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/it.svg');
            }

            &_pay {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/pay.svg');
            }

            &_premium {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/premium.svg');
            }

            &_calendar {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/calendar.webp');
            }

            &_wallet {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/wallet.webp');
            }

            &_terminal {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/terminal.webp');
            }

            &_schedule {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/schedule.webp');
            }

            &_house {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/house.svg');
            }

            &_loans {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/loans.svg');
            }

            &_cards {
                background-image: url('/local/templates/redesign/src/assets/img/main/services/cards.svg');
            }

            &_crown {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/crown.webp');
            }
            &_secure {
                background-image: url('/local/templates/redesign/src/assets/img/ico_glass/secure.webp');
            }
        }

        &-title {
            @include h4;
            @include fluid('margin-top', 32px);
            z-index: 2;
            position: relative;
        }

        &-subtitle {
            z-index: 2;
        }
    }

    &__pagination {
        bottom: 0;
        width: 100%;

        & .swiper-pagination-bullet {
            @include fluid('margin-right', 6px);
        }
    }

    &._sme {

        #{$b}__left {
            position: relative;
            @include fluid('width', 280px);
        }

    }
}
</style>
